module.exports = __webpack_public_path__ + "static/media/PushtimargImage38.d10dfbe9.jpg";